import CanvasButton from '../CanvasButton';

// Button that responds to clicks anywhere within the canvas.
export default class ClickVoid extends CanvasButton {
    checkUICollision(position) {
        return true;
    }

    onHoverEnter() {}

    onHoverMove(mousePositionP) {}

    onHoverExit() {}
}
